import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useApi } from "@/lib/api";
import { Container } from "@/components/site/PageHeader";
import { WeekPosterDialog, endOfWeek } from "@/components/site/WeekPosterDialog";

const day = (iso) => {
  const d = new Date(iso);
  return {
    weekday: d.toLocaleDateString("fr-FR", { weekday: "short" }).replace(".", ""),
    num: d.getDate(),
    time: d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }),
  };
};

// « Cette semaine » : up to 3 LGTDZ dates before Sunday night, hidden when the week is empty
export const ThisWeekBanner = () => {
  const { data } = useApi("/events", { when: "upcoming", limit: 20 });
  const limit = endOfWeek();
  const week = (Array.isArray(data) ? data : []).filter((e) => new Date(e.date) <= limit);
  const events = week.slice(0, 3);
  if (!events.length) return null;

  return (
    <section className="bg-white text-black border-y border-black" data-testid="home-this-week">
      <Container className="py-6 md:py-8 grid lg:grid-cols-[200px_1fr] gap-4 lg:gap-10 items-center">
        <div>
          <p className="font-display uppercase text-3xl md:text-4xl leading-none" data-testid="home-this-week-title">
            Cette<br className="hidden lg:block" /> <span className="text-primary">semaine</span>
          </p>
          <WeekPosterDialog testId="home-week-poster-btn"
            className="inline-flex items-center gap-2 mt-3 text-[11px] uppercase tracking-[0.2em] font-bold text-black underline decoration-primary decoration-2 underline-offset-4 hover:text-primary transition-colors" />
        </div>
        <ul className={`grid grid-cols-1 ${events.length > 1 ? "md:grid-cols-2" : ""} ${events.length > 2 ? "xl:grid-cols-3" : ""} gap-3`}>
          {events.map((e) => {
            const d = day(e.date);
            return (
              <li key={e.id}>
                <Link to={`/agenda/${e.slug}`} data-testid={`home-this-week-item-${e.id}`}
                  className="group flex items-center gap-4 h-full border-2 border-black px-4 py-3 hover:bg-black hover:text-white transition-colors duration-200">
                  <span className="flex flex-col items-center justify-center bg-primary text-white w-16 h-16 shrink-0">
                    <span className="text-[11px] uppercase font-bold tracking-[0.15em] leading-none">{d.weekday}</span>
                    <span className="font-display text-3xl leading-none mt-1">{d.num}</span>
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-display uppercase text-lg leading-tight line-clamp-2">{e.title}</span>
                    <span className="block text-sm text-zinc-600 group-hover:text-zinc-300 truncate mt-1">{d.time}{e.venue ? ` · ${e.venue}` : ""}{e.city ? `, ${e.city}` : ""}</span>
                  </span>
                  <ArrowUpRight className="w-5 h-5 shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </Link>
              </li>
            );
          })}
        </ul>
      </Container>
    </section>
  );
};
